import { Pagination } from '@/modules/shared/schemas/Pagination'

import { axios, Response } from '../index'

export enum PersonaStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  ACCESS_BLOCKED = 'ACCESS_BLOCKED'
}

export interface AccessProfile {
  id: string
  name: string
  personaType: string
}

export interface Operational {
  id: string
  appUserId: number
  name: string
  avatarName: string
  avatar: string
  accessProfiles: AccessProfile[]
  personaStatus: PersonaStatus
}

export default async function getClinicOperators({
  page = 1,
  size = 10,
  personaName,
  accessProfileId,
  personaStatus
}: {
  page?: number
  size?: number
  personaName?: string
  accessProfileId?: number
  personaStatus?: PersonaStatus
} = {}): Response<Pagination<Operational[]>> {
  const searchParams = new URLSearchParams()
  searchParams.set('page', page.toString())
  searchParams.set('size', size.toString())
  if (personaName) searchParams.set('personaName', personaName)
  if (accessProfileId)
    searchParams.set('accessProfileId', accessProfileId.toString())
  if (personaStatus) searchParams.set('personaStatus', personaStatus)

  return await axios.get(`/v1/operators?${searchParams.toString()}`)
}
